import React, { FC, useCallback } from 'react';
import { useTranslation } from 'next-i18next';

import { filterCategoriesIds } from 'src/common/boatCategories';
import { trackEvent } from 'src/common/3rdParty/tracking';
import getCategoryKeyById from 'src/common/utils/getCategoryKeyById';
import { GA_EVENT_FILTER } from 'src/common/gaEvents';
import Category from './Category';
import styles from './CategoriesFilter.module.scss';

export type CategoriesFilterProps = {
  selectedCategories: string[];
  onChange: (categories: string[]) => void;
};

const GA_PARAM_CATEGORIES = 'p8';

const CategoriesFilter: FC<CategoriesFilterProps> = ({ selectedCategories, onChange }) => {
  const [t, i18n] = useTranslation('search-page');
  const english = i18n.getFixedT('en', 'boat-categories');

  const handleOnChange = useCallback(
    (id: string, checked: boolean) => {
      const categoriesForUpdate = selectedCategories.filter((value) => value !== id);
      if (checked) {
        categoriesForUpdate.push(id);
      }
      onChange(categoriesForUpdate);
      if (categoriesForUpdate.length) {
        const categoryNames = categoriesForUpdate.map(
          (categoryId) => english(getCategoryKeyById(categoryId)),
        );
        trackEvent(GA_EVENT_FILTER, {
          [GA_PARAM_CATEGORIES]: categoryNames,
        });
      }
    },
    [selectedCategories, onChange, english],
  );

  return (
    <ul className={styles.root}>
      {filterCategoriesIds.map((groupCatId) => (
        <Category
          key={groupCatId}
          categoryId={groupCatId}
          name={t(getCategoryKeyById(groupCatId))}
          onChange={handleOnChange}
          checked={selectedCategories.includes(groupCatId)}
        />
      ))}
    </ul>
  );
};

export default CategoriesFilter;
